import { injectable } from 'inversify';

@injectable()
export class UserRouterService {
  goToTelegram(url: string) {
    window.open(url, '_blank');
  }
}
